// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics"; // 👈 add this line

const firebaseConfig = {
  apiKey: "AIzaSyBTd0QOmQ8XeMEso6bafb0F7qTOtBEveT8",
  authDomain: "kivora-co.firebaseapp.com",
  projectId: "kivora-co",
  storageBucket: "kivora-co.appspot.com",
  messagingSenderId: "507676540991",
  appId: "1:507676540991:web:072928d6e16d31ff72388a",
  measurementId: "G-XBR4E7D10J" // 👈 needed for Analytics
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
const analytics = getAnalytics(app); // 👈 add this line

// Export services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const provider = new GoogleAuthProvider();
export const storage = getStorage(app);
export { app, analytics }; // 👈 export analytics
